import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../_globals/globals';

interface HelpCatalogEntry {
  slug: string;
  order: number;
  title: string;
  summary: string;
}

interface HelpSection {
  title: string;
  paragraphs?: string[];
  steps?: string[];
  bullets?: string[];
  note?: string;
}

interface HelpArticle {
  slug: string;
  order: number;
  title: string;
  summary: string;
  sections: HelpSection[];
}

@Component({
  selector: 'app-help-center',
  templateUrl: './help-center.component.html',
  styleUrls: ['./help-center.component.css']
})
export class HelpCenterComponent implements OnInit {
  productTitle = 'Dimpro Prod';
  confidentiality = '';
  viewerName = '';
  catalog: HelpCatalogEntry[] = [];
  activeSlug = '';
  activeArticle: HelpArticle = null;
  loadingCatalog = false;
  loadingArticle = false;
  errorMessage = '';

  private readonly topicIcons = [
    'fa-compass',
    'fa-sliders-h',
    'fa-layer-group',
    'fa-industry',
    'fa-print',
    'fa-check-double'
  ];

  constructor(
    private http: HttpClient,
    private globals: Globals
  ) {}

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.loadCatalog();
  }

  loadCatalog(): void {
    this.loadingCatalog = true;
    this.errorMessage = '';
    this.http.get<any>(this.globals.apiUrl + '/help/catalog').subscribe(
      response => {
        this.loadingCatalog = false;
        this.productTitle = response && response.product && response.product.title
          ? response.product.title
          : 'Dimpro Prod';
        this.confidentiality = response && response.product
          ? (response.product.confidentiality || '')
          : '';
        this.viewerName = response && response.viewer
          ? (response.viewer.username || '')
          : '';
        this.catalog = response && Array.isArray(response.articles)
          ? response.articles
          : [];
        if (this.catalog.length > 0) {
          this.selectArticle(this.catalog[0].slug, false);
        }
      },
      error => {
        this.loadingCatalog = false;
        this.errorMessage = this.getErrorMessage(
          error,
          'No ha sido posible cargar la ayuda protegida.'
        );
      }
    );
  }

  selectArticle(slugIn: string, scrollIn = true): void {
    if (!slugIn || this.loadingArticle || slugIn === this.activeSlug && this.activeArticle) {
      return;
    }
    this.activeSlug = slugIn;
    this.activeArticle = null;
    this.loadingArticle = true;
    this.errorMessage = '';
    this.http.get<any>(
      this.globals.apiUrl + '/help/article/' + encodeURIComponent(slugIn)
    ).subscribe(
      response => {
        this.loadingArticle = false;
        this.activeArticle = response && response.article ? response.article : null;
        if (!this.activeArticle) {
          this.errorMessage = 'El capítulo solicitado no contiene información.';
          return;
        }
        if (scrollIn) {
          window.setTimeout(() => {
            const target = document.getElementById('protected-help-article');
            if (target) {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }, 20);
        }
      },
      error => {
        this.loadingArticle = false;
        this.errorMessage = this.getErrorMessage(
          error,
          'No ha sido posible cargar el capítulo.'
        );
      }
    );
  }

  topicIcon(indexIn: number): string {
    return this.topicIcons[indexIn % this.topicIcons.length];
  }

  topicTone(indexIn: number): string {
    return 'help-topic-card-icon--tone-' + (indexIn % 5).toString();
  }

  sectionNumber(indexIn: number): string {
    return (indexIn + 1).toString().padStart(2, '0');
  }

  trackCatalog(indexIn: number, itemIn: HelpCatalogEntry): string {
    return itemIn ? itemIn.slug : indexIn.toString();
  }

  trackSection(indexIn: number, itemIn: HelpSection): string {
    return itemIn && itemIn.title ? itemIn.title : indexIn.toString();
  }

  private getErrorMessage(errorIn: any, fallbackIn: string): string {
    if (errorIn && errorIn.error && errorIn.error.message) {
      return errorIn.error.message;
    }
    return fallbackIn;
  }
}
